import React from 'react'
import styled from '@emotion/styled/macro'
import mq from 'mediaQuery'

const offset = 180

const Content = styled('div')`
  margin-left: 8px;
  position: relative;

  h3 {
    margin-top: 2px;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 5px;
  }

  p {
    font-size: 12px;
    font-weight: 400;
    margin-top: 0;
    color: #adbbcd;
    line-height: 15px;
  }
`

const StepContainer = styled('div')`
  display: flex;
  position: relative;
  padding: 15px 0 0 20px;

  ${mq.medium`
    padding: 40px 0 0 40px;
  `}

  &:before {
    font-size: 40px;
    font-weight: 700;
    color: ${p => (p.progress === 100 ? '#FAECE4' : '#E8E8E9')};
    content: '${p => p.number}';
    position: absolute;
    left: 0;
    top: 0;

    ${mq.medium`
      font-size: 80px;
    `}
  }
`

const Step = ({ number, text, title, progress = 100 }) => (
  <StepContainer number={number} progress={progress}>
    <Content>
      <h3>{title}</h3>
      <p>{text}</p>
    </Content>
  </StepContainer>
)

export default Step
